import { render } from "./PortalShell.vue?vue&type=template&id=78583a46&scoped=true&ts=true&lang=pug"
import script from "./PortalShell.vue?vue&type=script&lang=ts"
export * from "./PortalShell.vue?vue&type=script&lang=ts"

import "./PortalShell.vue?vue&type=style&index=0&id=78583a46&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78583a46"]])

export default __exports__